import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnNeverbounceValidationComponent } from './dn-neverbounce-validation.component';
import { ComplexTooltipModule } from '../complex-tooltip/complex-tooltip.module';
import { HoverDirective } from '../directives/hover/hover.directive';

@NgModule({
  declarations: [DnNeverbounceValidationComponent, HoverDirective],
  imports: [CommonModule, ComplexTooltipModule],
  exports: [DnNeverbounceValidationComponent],
})
export class DnNeverbounceValidationModule {}
